import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'hk-module-help-video-modal',
  template: `
    <video
      class="w-full overflow-y-hidden object-scale-down"
      autoplay
      controls
      controlsList="nodownload"
      disablePictureInPicture="true"
      oncontextmenu="return false;"
      playsinline
      webkit-playsinline
    >
      <source [src]="videoUrlString" type="video/mp4" />
      <p>{{ 'help.noVideoSupport' | translate }}</p>
    </video>
  `,
  standalone: true,
  host: { class: 'flex flex-col justify-center' },
  imports: [TranslateModule],
})
export class ModuleHelpVideoModalComponent {
  @Input() public videoUrlString?: string;
}
